import { BuiltInPlan } from "../../lib/workout";

export default {
  id: "e4d80b18-a1e2-4e98-8948-0b2e0acdb64e",
  title:
    "Pfitzinger/Latter: 46 to 63 miles per week, 12-week schedule",
  sourceName: "Faster Road Racing: 5K to Half Marathon",
  sourceUrl: "https://www.amazon.com/gp/product/1450470459/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=1450470459&linkCode=as2&tag=codyhoover-20&linkId=6107e4706a5e1cc10836339bd7b312e0",
  raceType: "Half Marathon",
  units: "miles",
  workouts: [
    {
      totalDistance: 0,
      description: "Rest or cross-training"
    },
    {
      totalDistance: 9,
      description: "General aerobic 9 miles"
    },
    {
      totalDistance: 8,
      description: "Lacate threshold 8 miles w/ 15 min LT interval (jog 4 min recovery), 12 min LT interval"
    },
    {
      totalDistance: 10,
      description: "Endurance 10 miles"
    },
    {
      totalDistance: 0,
      description: "Rest or cross-training"
    },
    {
      totalDistance: 7,
      description: "General aerobic + speed 7 miles w/ 2 sets of 6x100m strides (jog 3 min between sets)"
    },
    {
      totalDistance: 12,
      description: "Endurance 12 miles"
    },
    {
      totalDistance: 0,
      description: "Rest or cross-training"
    },
    {
      totalDistance: 9,
      description: "General aerobic 9 miles"
    },
    {
      totalDistance: 9,
      description: "Lacate threshold 9 miles w/ 18 min LT interval (jog 4 min recovery), 14 min LT interval"
    },
    {
      totalDistance: 11,
      description: "Endurance 11 miles"
    },
    {
      totalDistance: 0,
      description: "Rest or cross-training"
    },
    {
      totalDistance: 7,
      description: "General aerobic + speed 7 miles w/ 6x12 sec uphill followed by 8x100m strides"
    },
    {
      totalDistance: 13,
      description: "Endurance 13 miles"
    },
    {
      totalDistance: 0,
      description: "Rest or cross-training"
    },
    {
      totalDistance: 9,
      description: "General aerobic 9 miles"
    },
    {
      totalDistance: 10,
      description: "Lacate threshold 10 miles w/ 20min LT interval (jog 4 min recovery), 16 min LT interval"
    },
    {
      totalDistance: 11,
      description: "Endurance 11 miles"
    },
    {
      totalDistance: 0,
      description: "Rest or cross-training"
    },
    {
      totalDistance: 8,
      description: "General aerobic + speed 8 miles w/ 6x12 sec uphill followed by 8x100m strides"
    },
    {
      totalDistance: 14,
      description: "Progression long run 14 miles, last 2 miles @ LT"
    },
    {
      totalDistance: 0,
      description: "Rest or cross-training"
    },
    {
      totalDistance: 8,
      description: "General aerobic 8 miles"
    },
    {
      totalDistance: 10,
      description: "General aerobic 10 miles"
    },
    {
      totalDistance: 9,
      description: "General aerobic + speed 9 miles w/ 2 sets of 5x150m strides (jog 250m between intervals and 4 min between sets)"
    },
    {
      totalDistance: 0,
      description: "Rest or cross-training"
    },
    {
      totalDistance: 9,
      description: "General aerobic 9 miles"
    },
    {
      totalDistance: 11,
      description: "Endurance 11 miles"
    },
    {
      totalDistance: 0,
      description: "Rest or cross-training"
    },
    {
      totalDistance: 9,
      description: "General aerobic 9 miles"
    },
    {
      totalDistance: 10,
      description: "Lacate threshold 10 miles w/ 22 min LT interval (jog 4 min recovery), 18 min LT interval"
    },
    {
      totalDistance: 11,
      description: "Endurance 11 miles"
    },
    {
      totalDistance: 3,
      description: "Recovery 3 miles"
    },
    {
      totalDistance: 8,
      description: "General aerobic + speed 8 miles w/ 2 sets of 6x100m strides (jog 3 min between sets)"
    },
    {
      totalDistance: 14,
      description: "Progression long run 14 miles, last 3 miles @ LT"
    },
    {
      totalDistance: 0,
      description: "Rest or cross-training"
    },
    {
      totalDistance: 9,
      description: "General aerobic 19 miles"
    },
    {
      totalDistance: 10,
      description: "V02Max 10 miles w/ 3x1,200m, 3x1,000m @ 3k-5k race pace (jog 50-90% interval time recovery)"
    },
    {
      totalDistance: 12,
      description: "Endurance 12 miles"
    },
    {
      totalDistance: 4,
      description: "Recovery 4 miles"
    },
    {
      totalDistance: 8,
      description: "General aerobic + speed 8 miles w/ 8x12 sec uphill followed by 8x100m strides"
    },
    {
      totalDistance: 15,
      description: "Endurance 15 miles"
    },
    {
      totalDistance: 0,
      description: "Rest or cross-training"
    },
    {
      totalDistance: 9,
      description: "General aerobic 9 miles"
    },
    {
      totalDistance: 10,
      description: "Lactate Threshold 10 miles, 40 min tempo run."
    },
    {
      totalDistance: 12,
      description: "Endurance 12 miles"
    },
    {
      totalDistance: 5,
      description: "Recovery 5 miles"
    },
    {
      totalDistance: 9,
      description: "General aerobic + speed 9 miles w/ 10x100m strides"
    },
    {
      totalDistance: 16,
      description: "Progression long run 16 miles, last 3 miles @ LT"
    },
    {
      totalDistance: 0,
      description: "Rest or cross-training"
    },
    {
      totalDistance: 10,
      description: "General aerobic + speed 10 miles w/ 2 sets of 5x150m strides (jog 250m between intervals and 4 min between sets)"
    },
    {
      totalDistance: 9,
      description: "General aerobic 9 miles"
    },
    {
      totalDistance: 7,
      description: "Recovery 7 miles"
    },
    {
      totalDistance: 4,
      description: "Recovery 4 miles w/ 4x100m strides"
    },
    {
      totalDistance: 10,
      description: "8k-10k tune-up race, 10 miles"
    },
    {
      totalDistance: 12,
      description: "Endurance 12 miles"
    },
    {
      totalDistance: 0,
      description: "Rest or cross-training"
    },
    {
      totalDistance: 9,
      description: "General aerobic 9 miles"
    },
    {
      totalDistance: 11,
      description: "Endurance 11 miles"
    },
    {
      totalDistance: 11,
      description: "V02Max 11 miles w/ 6x1,200m @ 3k-5k race pace (jog 50-90% interval time recovery)"
    },
    {
      totalDistance: 6,
      description: "Recovery 6 miles"
    },
    {
      totalDistance: 10,
      description: "General aerobic 10 miles"
    },
    {
      totalDistance: 16,
      description: "Endurance 16 miles"
    },
    {
      totalDistance: 0,
      description: "Rest or cross-training"
    },
    {
      totalDistance: 10,
      description: "General aerobic + speed 10 miles w/ 2 sets of 5x150m strides (jog 250m between intervals and 4 min between sets)"
    },
    {
      totalDistance: 9,
      description: "General aerobic 9 miles"
    },
    {
      totalDistance: 7,
      description: "Recovery 7 miles "
    },
    {
      totalDistance: 4,
      description: "Recovery 4 miles w/ 4x100m strides"
    },
    {
      totalDistance: 10,
      description: "8k-10k tune-up race, 10 miles"
    },
    {
      totalDistance: 12,
      description: "Endurance 12 miles"
    },
    {
      totalDistance: 0,
      description: "Rest or cross-training"
    },
    {
      totalDistance: 7,
      description: "General aerobic 7 miles"
    },
    {
      totalDistance: 5,
      description: "Recovery 5 miles"
    },
    {
      totalDistance: 10,
      description: "V02Max 10 miles w/ 2x1,200m, 4x800m @ 3k-5k race pace (jog 50-90% interval time recovery)"
    },
    {
      totalDistance: 4,
      description: "Recovery 4 miles"
    },
    {
      totalDistance: 6,
      description: "General aerobic + speed 6 miles w/ 2 sets of 6x100m strides (jog 3 min between sets)"
    },
    {
      totalDistance: 11,
      description: "Endurance 11 miles"
    },
    {
      totalDistance: 0,
      description: "Rest or cross-training"
    },
    {
      totalDistance: 8,
      description: "Race pace + speed 8 miles w/ 2 miles @ half marathon race pace and 6x100m strides"
    },
    {
      totalDistance: 7,
      description: "Recovery 7 miles"
    },
    {
      totalDistance: 6,
      description: "Recovery 6 miles"
    },
    {
      totalDistance: 0,
      description: "Rest"
    },
    {
      totalDistance: 4,
      description: "Recovery 4 miles w/ 4x100m strides"
    },
    {
      totalDistance: 17,
      description: "Half Marathon goal race 17 miles"
    }
  ]
} as BuiltInPlan;
